module.exports = __webpack_public_path__ + "assets/img/sabc_main_featured_playicon.webp?3015e1c1edd30adc05b64ca799ad2a65";